<template>
	<div class="wrapper form">
		<div class="bgcolor-turquoise">
			<p class="p-15px mb-0">
				Biztosított az a személy, akit terhelő kártérítési kötelezettséget a biztosító jelen feltételek alapján
				teljesíti. Ők
			</p>
			<ol class="mb-0 mt-0">
				<li>tulajdonos és a tulajdonostársak tulajdoni hányaduk arányában;</li>
				<li>haszonélvező;</li>
				<li>bérlő, bérlőtárs;</li>
				<li>és az ingatlant egyéb jogcímen jogszerűen használó személy.</li>
				<li>
					azok, akik a biztosítási esemény bekövetkeztekor az a), b), c) pontokban felsorolt biztosítottakkal
					a kockázatviselés helyén állandó jelleggel, együtt laktak.
				</li>
			</ol>
			<p class="p-15px">
				Minősített Fogyasztóbarát Otthonbiztosítás biztosítottja csak fogyasztó (magánszemély) lehet!
			</p>
		</div>
		<div class="input-wrapper" v-for="index in insureds" :key="index">
			<div class="input__title">{{ index }}. Biztosított adatai:</div>
			<div class="input__flied mb-15px" v-if="index === 1">
				<CalcElem
					name="firstInsuredDataIsContract"
					:options="{
						label: 'A biztosított megegyezik a szeződővel.',
						type: 'checkbox',
						wrapperClass: 'col-w100-chbox chbox_style-wrapper',
						className: 'mw-500px',
						prop: 'firstInsuredDataIsContract',
					}"
					type="contracting"
					class="checkbox-center"
					@click="handleClick"
				/>
			</div>
			<div class="input__field">
				<CalcElem
					v-for="(field, fIndex) in comutedInsuredsFields(index)"
					:key="fIndex"
					:options="field"
					type="contracting"
					:class="field.inputClass"
					:index="index"
					:name="fIndex"
					:ref="`insuredData-insuredsData-${index}-${fIndex}`"
					:disabled="isDisabledFirstInsured(index)"
				/>
				<div class="rows w-100 mt-12px" v-if="index > getCalculation.real_estate.inhabitants">
					<div class="input__delete text-center" @click="deleteInsured(index)">Eltávolítás</div>
				</div>
			</div>
		</div>
		<div class="input-wrapper">
			<div class="input__more" @click="addInsured" v-if="insureds.length < 5">
				<span>További biztosított hozzáadása</span>
			</div>
		</div>
	</div>
</template>

<script>
import _ from 'lodash';
import dataPages from '@/mixins/dataPages';
import insuredData from '@/mixins/insuredData';
import insureds from '@/mixins/insureds';
import { mapMutations } from 'vuex';

export default {
	mixins: [dataPages, insuredData, insureds],
	data() {
		return {
			insurer: 'generali',
			type: 'insuredData',
		};
	},
	computed: {
		isDisabledFirstInsured() {
			return index => this.getCheckboxData('firstInsuredDataIsContract') && index === 1;
		},
	},
	methods: {
		...mapMutations('contracting', ['deleteInsuredsInsuredData']),
		handleClick() {
			const fields = ['last_name', 'first_name', 'birth_date'];

			fields.forEach(field => {
				this.setFormData({
					parent: 'insuredData',
					group: 'insuredsData',
					prop: field,
					value: !this.getCheckboxData('firstInsuredDataIsContract')
						? this.getFormData({
								parent: 'baseData',
								group: 'contractDetails',
								prop: field,
						  })
						: null,
					index: 1,
				});
			});
		},
		addInsured() {
			this.insureds.push(this.insureds[this.insureds.length - 1] + 1);
		},
		deleteInsured(index) {
			const key = this.insureds.findIndex(insured => insured === index);
			this.insureds.splice(key, 1);
			this.insureds = Array.from({ length: this.insureds.length }, (_, i) => i + 1);
			this.deleteInsuredsInsuredData(index);
		},
	},
};
</script>
